import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import BankAccountList from "../../components/BankAccount/List/BankAccountList";
import { withRouter } from "react-router";

const BankAccountListPage = (props) => {
  return (
    <Wrapper>
      <BreadcrumbsTemp
        items={[
          {
            title: "لیست معاملات ماشین",
            to: "/car-contract/list",
          },
        ]}
      />

      <Grid container={true}>
        <Grid item xs={12}>
          <BankAccountList
            name={props.match.params.name}
            user={props.match.params.id}
          />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default withRouter(BankAccountListPage);
